import AddReportModal from './containers/AddReportModalContainer'

export default AddReportModal
